import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { DomSanitizer } from '@angular/platform-browser';
import { FirebaseUserModel } from '../data-model/user.model';
import { AuthService } from '../services/auth.service'; 
import { DatabaseService } from '../services/database.service';
import { EventEmitterService } from '../services/event-emitter.service';
import { ProfileTypes } from '../utilities';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {

  profileTypes = ProfileTypes;
  userData: FirebaseUserModel;
  userImageUrlSanitizer = null;

  constructor(
    public afAuth: AngularFireAuth,
    public auth: AuthService,
    private database: DatabaseService,
    private eventEmitterService: EventEmitterService,
    private sanitizer: DomSanitizer
    ) { }

  ngOnInit(): void {
    this.afAuth.user.subscribe(result => {
      if(result){
        result.uid;
        this.database.getUser(result.uid).get().then(data => {
          var d = data.data();
          this.userData = FirebaseUserModel.objectUserToModel(d);
          if (this.userData.imageUrl) {
            this.userImageUrlSanitizer = this.sanitizer.bypassSecurityTrustResourceUrl(this.userData.imageUrl);
          }else{
            this.userImageUrlSanitizer = null;
          }
        });
      }
    })
  }

}
